var map = {
	"./images/Print sticker-1.png": 27232,
	"./images/biryaniWala.png": 29367,
	"./images/burger.png": 8952,
	"./images/concaveLogo.png": 86376,
	"./images/customer.png": 97438,
	"./images/dashboardBG.png": 26959,
	"./images/default-user-image.jpg": 10131,
	"./images/default-user-image1.jpg": 45862,
	"./images/error-404.png": 91344,
	"./images/error-500.png": 31166,
	"./images/error-bg.jpg": 1632,
	"./images/graph_image.png": 10006,
	"./images/login-bg.jpg": 85338,
	"./images/mlogo.png": 11221,
	"./images/pos.png": 30555,
	"./images/profilepic": 91756,
	"./images/profilepic.png": 62326,
	"./images/somethingWentWrong.png": 56525,
	"./images/srbPOS.png": 23739,
	"./images/ygen.png": 38880,
	"./refImages/upload-logo.png": 54434,
	"./sounds/orderSound.mp3": 83022,
	"./sounds/swiftly.mp3": 86894,
	"./sounds/swiftly1.mp3": 10827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;